import type { QuizBoardCell, QuizBoardQuiz } from "@quizshow/protocol";

export const quizBoardModuleManifest = {
  id: "quizboard",
  version: 1,
  name: "Quizboard",
  capabilities: ["teams", "scoring", "lives", "buzzer", "question_timer", "submissions", "special_cells"],
} as const;

function createCell(points: number): QuizBoardCell {
  return {
    cellId: crypto.randomUUID(),
    points,
    special: "none",
    question: {
      questionId: crypto.randomUUID(),
      prompt: `Frage für ${points} Punkte`,
      answers: [
        { optionId: crypto.randomUUID(), text: "Richtige Antwort", isCorrect: true },
        { optionId: crypto.randomUUID(), text: "Falsche Antwort", isCorrect: false },
      ],
      timerEnabled: true,
      timerSeconds: 300,
      points,
      fiftyFiftyRemoveCount: 1,
      questionType: "normal",
      answerMode: "multiple-choice",
      selectionMode: "single",
      evaluationMode: "manual",
      media: {},
    },
  };
}

export function createStarterQuizBoard(): QuizBoardQuiz {
  return {
    formatVersion: 1,
    quizId: crypto.randomUUID(),
    moduleId: "quizboard",
    moduleVersion: 1,
    title: "Mein Quizboard",
    description: "Kategorien, Punktefelder und Teamduelle.",
    updatedAt: new Date().toISOString(),
    mediaAssets: [],
    allowSelfTeamSelection: true,
    allowParticipantJokers: false,
    autoOpenBuzzer: false,
    scoringMode: "points",
    ranks: [],
    jokers: [],
    usesLives: false,
    defaultLives: 3,
    theme: {
      primaryColor: "#8f1838",
      accentColor: "#ef4565",
      backgroundColor: "#100b11",
    },
    categories: ["Wissen", "Kultur", "Technik"].map((name) => ({
      categoryId: crypto.randomUUID(),
      name,
      cells: [100, 200, 300, 400].map(createCell),
    })),
  };
}
